import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=09147f90&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09147f90",
  null
  
)

export default component.exports